import React from 'react';

const ProductType = React.lazy(() => import('./productType/ProductType'));
const BusinessType = React.lazy(() => import('./businessType/BusinessType'));

const CONFIG_ROUTE = '/config';

const productTypeRoute = CONFIG_ROUTE + '/product-type';
const businessTypeRoute = CONFIG_ROUTE + '/business-type';

export const configRouteConfigs = [
  {
    path: businessTypeRoute,
    element: <BusinessType />,
  },
  {
    path: productTypeRoute,
    element: <ProductType />,
  },
];
